import Entry from '../components/Entry';
import EntryConfig from '../components/entryconfigType';
import '../Default.css';


const menuItems: EntryConfig[] = [
  {
    img:"/icons/clipboard-list-solid.svg",
    img_alt: "shedule",
    link: "/shedule",
    text: "harmonogram"
  },
  {
    img:"/icons/book-open-solid.svg",
    img_alt: "reading",
    link: "/reading",
    text: "czytania"
  },
  {
    img:"/icons/people-roof-solid.svg",
    img_alt: "meetings",
    link: "/meetings",
    text: "spotkania katechetyczne"
  },
  {
    img:"/icons/hand-holy-solid.svg",
    img_alt: "saints",
    link: "/saints",
    text: "patroni"
  },
  {
    img:"/icons/scroll-solid.svg",
    img_alt: "hymn",
    link: "/hymn",
    text: "hymn"
  }
]

function SDM() {
    return (
      <>
        <div className="page-title">
          ŚDM
        </div>
        <div className="navigation-wraper">
          <nav className="navigation-bar">
            {menuItems.map((v,i) => <Entry conf={v} key={i}/>)}
          </nav>
        </div>
      </>
    );
}

export default SDM;